import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import SectionLoadingcontainer from './sectionloadingcontainer';
import { updateAppState, updateComponentState } from '../actions/actions';

class EquipmentCondemnation extends Component {
	constructor(props) {
		super(props);
		this.state = {
			equipmentcondemnation : [],
			totalequipmentcondemnation : 0,
			loaderflag : true
		};
		this.onload = this.onload.bind(this);
		this.tileOnClick = this.tileOnClick.bind(this);
	}

	componentWillMount() {
		this.onload();
	}

	onload(){
		if(this.props.componentdata){
			this.setState({
				...this.props.componentdata
			});
		}else{
			axios.get(`/api/equipmentcondemnation?pagetype=widget`).then((response) => {
				if (response.data.message == 'success') {
					
					let equipmentcondemnation=[], totalequipmentcondemnation=0;
					if(response.data.main && response.data.main.length > 0){
						response.data.main.forEach((item)=>{
							totalequipmentcondemnation += item.proposed;
						});

						equipmentcondemnation = response.data.main;
					}

					this.setState({
						equipmentcondemnation,
						totalequipmentcondemnation,
						loaderflag : false
					});

					this.props.updateComponentState(this.props.form,{
						equipmentcondemnation,
						totalequipmentcondemnation,
						loaderflag : false
					});
				} else {
					console.log(response);
				}
			});
		}
	}

	tileOnClick(){
		if((this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New','Tata'].includes(this.props.app.branch)) || this.props.app.companyid == 7) this.props.history.push("/equipmentcondemnationbygroup");
		else if (this.props.app.companyid == 8) this.props.history.push({pathname: `/equipmentcondemnationbyhospital/null`, params: {groupid: null,territoryid:null}});
		else if(this.props.app.companyid == 6 || (this.props.app.companyid == 1 && ['Sysmex'].includes(this.props.app.branch))) this.props.history.push("/equipmentcondemnationbystate");
		else this.props.history.push("/equipmentcondemnationbydistrict");

	}

	render() {
		let { equipmentcondemnation,totalequipmentcondemnation,loaderflag } = this.state;
		return (
			<div className="row no-gutters h-100" onClick={()=>{this.tileOnClick()}}>
				<div className="col-md-12">
					<SectionLoadingcontainer isloading={loaderflag}></SectionLoadingcontainer>
					<div className="row">
						<div className="col-md-12">
							<div  className="section-header-title-small" style={{float:'left',color: "#008060"}}>Equipment Condemnation</div>
							<div className="section-count-small" style={{float:'right',color: "#405FFF"}}> {totalequipmentcondemnation}</div>
						</div>
					</div>
					<div className="row">	
						<div className="col-md-12">
							{equipmentcondemnation.length > 0 ? <table className="table dashboardwidget">
								<thead>
									<tr>
										<th style={{width:"40%"}}></th>
										<th className="text-center table-content-small">Proposed</th>
										<th className="text-center table-content-small">Approved</th>
									</tr>
								</thead>
								<tbody>
									{equipmentcondemnation.map((item, key) => {
										return <tr key={key}>
											<td className="text-left table-content-small">{item.type}</td>
											<td className="text-center table-body-count">{item.proposed}</td>
											<td className="text-center table-body-count">{item.approved}</td>
										</tr>
									})}
								</tbody>
							</table> : null}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

EquipmentCondemnation = connect(
	(state, props) => {
		let formName = 'equipmentcondemnation';

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateAppState, updateComponentState }
)(reduxForm()(EquipmentCondemnation));

export default EquipmentCondemnation;


// WEBPACK FOOTER //
// ./public/react/components/equipmentcondemnation.js